import React from "react";
import Main from "./Main";
import ThemeWrapper from "./theme/ThemeWrapper";
import { CameraStatusProvider } from "./components/context/CameraStatusContext";

function App() {
  
  return (
  <>
  <ThemeWrapper>
      <CameraStatusProvider>
        <Main />
      </CameraStatusProvider>     
    </ThemeWrapper>
  </>
  )
} 
export default App;
